<div class="absolute inset-0" (onResize)="handleContainerResize($event)" #container>

  <webcam *ngIf="width && height"
    [width]="width"
    [height]="height"
  >
  </webcam>

</div>


